/**
 * Converts camelCase or PascalCase strings to kebab-case
 * @param str - The input string in camelCase or PascalCase
 * @returns The converted string in kebab-case format
 */
export function toKebabCase(str: string): string {
	return str
		.replace(/([A-Z]+)([A-Z][a-z])/g, '$1-$2') // Handle consecutive capitals like "TShirt"
		.replace(/([a-z])([A-Z])/g, '$1-$2') // Insert hyphen between lowercase and uppercase
		.toLowerCase(); // Convert entire string to lowercase
}
